import { deserialize } from 'cerialize'
import { ChannelCategory } from 'Constants/Channel/channelCategory'

export class ChannelModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public autoconfirm: boolean
	@deserialize public autocreate_unblock_request: boolean
	@deserialize public category: ChannelCategory
	@deserialize public channel_name: string
	@deserialize public created_at: string
	@deserialize public created_by_user_id: number
	@deserialize public is_active: boolean
	@deserialize public is_deleted: boolean
	@deserialize public order_prefix: string
	@deserialize public skip_call: boolean
	@deserialize public updated_at: string
	@deserialize public updated_by_user_id: number
	@deserialize public is_merchant_join: boolean
	@deserialize public sber_api_name: string
}
